import { Asset, TenantUserSettings } from '@/api/generatedApi';
import { createContext } from 'react';
import { AssetWithMatchData } from './CompareCartProvider';
import { MatchData } from '@/types/matchData';

export interface CompareCartState {
  selectedForCompare: { asset?: AssetWithMatchData };
  setSelectedForCompare: (selection: { asset?: AssetWithMatchData }) => void;
  isSelected: (assetId: string) => boolean;
  clearCart: () => void;
  getCompareUrl: (asset1: Asset, asset2: Asset, userSettings?: TenantUserSettings[], matchData?: MatchData) => string;
}

export const CompareCartContext = createContext<CompareCartState | undefined>(undefined);
